import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1020"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M11.863 10.27h-1.431a.071.071 0 0 1-.06-.109l1.36-2.103a.152.152 0 0 0-.128-.235H9.157a.297.297 0 0 0-.261.154l-1.819 3.278a.217.217 0 0 0 .19.323H8.73c.047 0 .081.045.068.091L7.79 15.13l4.231-4.495a.216.216 0 0 0-.158-.365z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M14.57 3.689s-6.977-2.06-9.323-2.672a.695.695 0 0 0-.836.497L1.028 14.12a.708.708 0 0 0 .476.847.71.71 0 0 0 .876-.485l1.462-5.45 10.829-4.214a.607.607 0 0 0-.101-1.129z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }